<div class="tab-container">
  <div class="actions">
    <app-button (btnClick)="downloadEventReport()" styleType="outlined" icon="pi pi-download">
      Baixar Relatório
    </app-button>
  </div>
  <app-sales-overview-section />
  <app-sales-resume-section />
</div>
